<!-- src/views/BuildingConstruction.vue -->
<template>
    <div>
      <h1>Travel</h1>
      <p>Content for Travel Page</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "Travel",
  };
  </script>
  